import { useState, useEffect } from "react";
import {
  Container,
  Box,
  Paper,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid
} from "@mui/material";
import Logocolor from "../../Image/Logo.png";
import { TituloPrincipal, InputBuscador, buttonGuardar, Texto, TextoTablaIngresoEgreso } from "../../Layouts/CustomStyles";
import { useGetFlujoCaja } from "../../Services/FlujodeCaja";
import DownloadIcon from "@mui/icons-material/Download";
import { useGetSucursal } from "../../Services/Sucursales";
import { HandleExportarFlujodeCajaCBO } from "../../Components/FuncionesGenerales/excel/ExcelFlujodeCajaCBO";

export const PaginaFlujoIngreso = () => {
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const { flujocaja, loadingFlujoCaja } = useGetFlujoCaja(fechaInicio, fechaFin);
  const {sucursales} = useGetSucursal();

  const [periodosVisibles, setPeriodosVisibles] = useState([]);
  console.log(periodosVisibles)
  // 🔹 Formato CLP
  const formatoCLP = (monto) =>
    `$${parseInt(monto).toLocaleString("es-CL", { minimumFractionDigits: 0 })}`;

  const periodos = flujocaja?.periodos || [];

  // 🔹 Calcular los 3 últimos períodos al inicio
  useEffect(() => {
    if (!flujocaja?.periodos) return;

    const periodosOrdenados = [...flujocaja.periodos].reverse(); // más recientes primero
    let visibles = [];

    // Si no hay rango seleccionado, mostrar los 3 últimos
    if (!fechaInicio && !fechaFin) {
      visibles = periodosOrdenados.slice(0, 3);
    } else {
      // Si hay rango, filtrar por las fechas seleccionadas
      const filtrados = periodosOrdenados.filter((p) => {
        const fechaPeriodo = new Date(p.mes);
        const desde = fechaInicio ? new Date(fechaInicio) : null;
        const hasta = fechaFin ? new Date(fechaFin) : null;

        if (desde && hasta) return fechaPeriodo >= desde && fechaPeriodo <= hasta;
        if (desde) return fechaPeriodo >= desde;
        if (hasta) return fechaPeriodo <= hasta;
        return true;
      });

      visibles = filtrados.slice(0, 3); // mostrar máximo 3
    }

    setPeriodosVisibles(visibles.reverse()); // volver a orden cronológico
  }, [flujocaja, fechaInicio, fechaFin]);

  // 🔹 Para selects
  const periodosHasta = fechaInicio
    ? periodos.filter((p) => new Date(p.mes) > new Date(fechaInicio))
    : periodos.slice(1);

  // 🔹 Tipos únicos
  const tiposIngresos = Array.from(
    new Set(periodos.flatMap((p) => p.detalle.ingresos.map((i) => i.tipo)))
  );
  const tiposEgresos = Array.from(
    new Set(periodos.flatMap((p) => p.detalle.egresos.map((i) => i.tipo)))
  );


  const [open, setOpen] = useState(false);
  const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);

 const handleOpenDetalle = (items, tipo) => {

  setDetalleSeleccionado({ items, tipo });
  setOpen(true);
};
  const handleClose = () => setOpen(false);


  if (loadingFlujoCaja) {
    return (
      <Box
        sx={{
          height: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Poppins",
        }}
      >
        <CircularProgress size={80} thickness={5} sx={{ color: "#19d298ff", mb: 2 }} />
        <Typography variant="h6" sx={{ fontFamily: 'Poppins', color: '#585857' }}>Cargando información del flujo de caja...</Typography>
      </Box>
    );
  }
  return (
    <Container maxWidth="xl">
      <Paper
        elevation={6}
        sx={{
          p: 4,
          borderRadius: "16px",
          backgroundColor: "#fafafa",
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          fontFamily: "Poppins",
        }}
      >
        {/* Encabezado */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box display="flex" alignItems="center" gap={2}>
            <img src={Logocolor} alt="Logo CBO" style={{ width: 55, height: 55 }} />
            <Typography variant="h5" sx={TituloPrincipal}>
              Flujo de Caja CBO
            </Typography>
          </Box>


          {/* Filtros */}
          <Box display="flex" justifyContent="flex-end" gap={2} mb={3}>
            <FormControl size="small" sx={{ ...InputBuscador, minWidth: 150 }}>
              <InputLabel id="select-periodo-desde">Desde</InputLabel>
              <Select
                labelId="select-periodo-desde"
                value={fechaInicio}
                label="Desde"
                onChange={(e) => setFechaInicio(e.target.value)}
              >
                {periodos.map((p, idx) => (
                  <MenuItem key={idx} value={p.mes}>
                    {p.mes}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ ...InputBuscador, minWidth: 150 }}>
              <InputLabel id="select-periodo-hasta">Hasta</InputLabel>
              <Select
                labelId="select-periodo-hasta"
                value={fechaFin}
                label="Hasta"
                onChange={(e) => setFechaFin(e.target.value)}
              >
                {periodosHasta.map((p, idx) => (
                  <MenuItem key={idx} value={p.mes}>
                    {p.mes}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              sx={{
                color: '#fff',
                padding: '5px 20px',
                backgroundColor: "#2a8d74",
                borderRadius: "50px",
                textTransform: "none",
                fontFamily: "Poppins",
              }}
              onClick={() => {
                setFechaInicio("");
                setFechaFin("");
              }}
            >
              Limpiar
            </Button>
          </Box>
        </Box>
        <Box sx={{mb:2}}>
        <Button
  sx={{
    color: "#fff",
    padding: "5px 20px",
    backgroundColor: "#2a8d74",
    borderRadius: "50px",
    textTransform: "none",
    fontFamily: "Poppins",
    display: "flex",
    alignItems: "center",
    gap: 1, // espacio entre icono y texto
  }}
  onClick={() => HandleExportarFlujodeCajaCBO(periodosVisibles, sucursales)}
>
  <DownloadIcon sx={{ fontSize: 20 }} />
  Descargar Flujo de Caja
</Button>


        </Box>

        {/* Tabla tipo Excel */}
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "#e0f7fa" }}>
              <TableRow>
                <TableCell sx={{...TextoTablaIngresoEgreso, fontWeight: 600 }}>Concepto</TableCell>
                {periodosVisibles.map((p, index) => (
                  <TableCell key={index} align="center" sx={{...TextoTablaIngresoEgreso, fontWeight: 600 }}>
                    {p.mes}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

         <TableBody>

  {/* SI NO HAY INFORMACIÓN */}
  {periodosVisibles.length === 0 && (
    <TableRow>
      <TableCell
        colSpan={1 + periodosVisibles.length}
        align="center"
        sx={{ py: 4, fontSize: "1rem", color: "#777" }}
      >
        No se encuentran registros
      </TableCell>
    </TableRow>
  )}

  {/* SI HAY INFORMACIÓN → SE RENDERIZA EL CONTENIDO */}
  {periodosVisibles.length > 0 && (
    <>
      {/* Flujo Neto */}
      <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
          Flujo Neto
        </TableCell>
      {periodosVisibles.map((p, i) => (
  <Tooltip title="Ver detalle del flujo neto por sucursal" arrow key={i}>
    <TableCell
      align="center"
      sx={{
        ...TextoTablaIngresoEgreso,
        fontWeight: 600,
        cursor: "pointer",
      }}
      onClick={() =>
        handleOpenDetalle(
          {
             detalle: p.detalle_sucursal || [],
      
          },
          "Flujo Neto "
        )
      }
    >
      {loadingFlujoCaja ? (
        <CircularProgress size={20} />
      ) : (
        formatoCLP(p.flujo_caja)
      )}
    </TableCell>
  </Tooltip>
))}
      </TableRow>

      {/* Total Ingresos */}
      <TableRow sx={{ backgroundColor: "#e8f5e9" }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
          Total Ingresos
        </TableCell>
        {periodosVisibles.map((p, i) => (
          <TableCell key={i} align="center" sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500 }}>
            {loadingFlujoCaja ? (
              <CircularProgress size={20} />
            ) : (
              formatoCLP(p.total_ingresos)
            )}
          </TableCell>
        ))}
      </TableRow>

      {/* Detalle Ingresos */}
      {tiposIngresos.map((tipo, idx) => (
        <TableRow key={`ingreso-${idx}`}>
          <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500 }}>
            {tipo}
          </TableCell>
          {periodosVisibles.map((p, i) => {
            const matches = p.detalle.ingresos?.filter((x) => x.tipo === tipo);
            const total = matches?.reduce((acc, item) => acc + Number(item.monto), 0);
            return (
              <Tooltip title="Ver detalle del monto" arrow>
  <TableCell
    key={i}
    align="center"
    sx={{ ...TextoTablaIngresoEgreso, color: "#19c87cff", cursor: "pointer" }}
    onClick={() => handleOpenDetalle(matches, "Ingreso")}
  >
    {matches?.length ? formatoCLP(total) : "-"}
  </TableCell>
</Tooltip>
            );
          })}
        </TableRow>
      ))}

      {/* Total Egresos */}
      <TableRow sx={{ backgroundColor: "#ffebee" }}>
        <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 600 }}>
          Total Egresos
        </TableCell>
        {periodosVisibles.map((p, i) => (
          <TableCell key={i} align="center" sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500 }}>
            {loadingFlujoCaja ? (
              <CircularProgress size={20} />
            ) : (
              formatoCLP(p.total_egresos)
            )}
          </TableCell>
        ))}
      </TableRow>

      {/* Detalle Egresos */}
      {tiposEgresos.map((tipo, idx) => (
        <TableRow key={`egreso-${idx}`}>
          <TableCell sx={{ ...TextoTablaIngresoEgreso, fontWeight: 500 }}>
            {tipo}
          </TableCell>
          {periodosVisibles.map((p, i) => {
           const matches = p.detalle.egresos?.filter((x) => x.tipo === tipo);
           const total = matches?.reduce((acc, item) => acc + Number(item.monto), 0);
            return (
               <Tooltip title="Ver detalle del monto" arrow>
    <TableCell
      key={i}
      align="center"
      sx={{ ...TextoTablaIngresoEgreso, color: "#b71c1c", cursor: "pointer" }}
      onClick={() => handleOpenDetalle(matches, "Egreso")}
    >
      {matches?.length ? formatoCLP(total) : "-"}
    </TableCell>
  </Tooltip>
            );
          })}
        </TableRow>
      ))}
    </>
  )}

</TableBody>

          </Table>
        </TableContainer>

        {/* Dialog Detalle */}
        <Dialog
  open={open}
  onClose={handleClose}
  maxWidth="lg" // 🔹 Permite mayor tamaño base
  fullWidth 
  PaperProps={{
    sx: {
      borderRadius: 5, // 🔹 Hace el cuadro rectangular
      padding: 2,
    },
  }}
>
  <DialogTitle sx={{ ...Texto, fontWeight: 600 }}>
    Detalle del {detalleSeleccionado?.tipo}
  </DialogTitle>

<DialogContent dividers>
  {detalleSeleccionado?.tipo === "Flujo Neto " && (
    <Box>
      
        <Grid container spacing={2}>
        
        {/* 🔵 INGRESOS (IZQUIERDA) */}
        <Grid size={12}>
        

          {detalleSeleccionado?.items?.detalle?.map((item, index) => (
            <Box
              key={index}
              sx={{
                mb: 1.5,
                p: 1.5,
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                backgroundColor: "#f1f8e9",
              }}
            >
              <Typography sx={{fontFamily:'Poppins'}}>
                <b>Sucursal:</b>{" "}
                {sucursales?.find((s) => String(s.id) === String(item.branch_id))?.name ||
                  item.sucursal ||
                  "Sin sucursal"}
              </Typography>

              <Typography sx={{fontFamily:'Poppins'}}>
                <b>Monto:</b> {formatoCLP(item.flujo_neto)}
              </Typography>
            </Box>
          ))}
        </Grid>

       
      </Grid>


    </Box>
  )}

  {/* fallback por si quieres reutilizar otros tipos */}
 {detalleSeleccionado?.tipo !== "Flujo Neto " &&
  Array.isArray(detalleSeleccionado?.items) &&
  detalleSeleccionado.items.map((item, index) => (
      <Box key={index} sx={{ mb: 2, borderBottom: "1px solid #ddd", pb: 1 }}>
        <Typography>
          <b>Fecha:</b>{" "}
          {item.fecha_registro
            ? new Date(item.fecha_registro).toLocaleDateString("es-CL")
            : "-"}
        </Typography>

        <Typography>
          <b>Sucursal:</b>{" "}
          {sucursales?.find((s) => String(s.id) === String(item.branch_id))?.name ||
            item.sucursal ||
            "Sin sucursal"}
        </Typography>

        <Typography>
          <b>Descripción:</b> {item.descripcion || "Sin descripción"}
        </Typography>

        <Typography>
          <b>Monto:</b> {formatoCLP(item.monto || item.total)}
        </Typography>
      </Box>
    ))}
</DialogContent>

  <DialogActions>
    <Button onClick={handleClose} sx={buttonGuardar}>
      Cerrar
    </Button>
  </DialogActions>
</Dialog>

      </Paper>
    </Container>
  );
};
